import { Formik, Form, ErrorMessage, FormikValues } from "formik";
import * as Yup from "yup";

import { useAppDispatch } from "@redux/store";
import { fetchFeedback } from "@redux/feedback/asyncActions";
import { IFeedbackFieldData } from "@/redux/feedback/types";

import {
  NameInput,
  EmailInput,
  PhoneInput,
  Button,
  TextareaInput,
  CheckBox,
} from "@/components";

import { getTokenFromStorage } from "@/utils";
import { ValidMessages } from "@/resources/locale";

import styles from "./FeedbackForm.module.scss";
import { openAuthModal } from "@/utils/authModal/openAuthModal";
import { PolicyCheckbox } from "@/components/PolicyCheckbox/PolicyCheckbox";

export const FeedbackForm = () => {
  const dispatch = useAppDispatch();

  const initialValues: IFeedbackFieldData = {
    name: "",
    email: "",
    phone: "",
    message: "",
    acceptTerms: false,
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(ValidMessages.inputs.name.REQUIRED),
    email: Yup.string()
      .email(ValidMessages.inputs.email.INCORRECT)
      .required(ValidMessages.inputs.email.REQUIRED),
    phone: Yup.string()
      .min(16, ValidMessages.inputs.phone.NOT_FULL)
      .required(ValidMessages.inputs.phone.REQUIRED),
    message: Yup.string()
      .min(10, ValidMessages.inputs.message.NOT_FULL)
      .required(ValidMessages.inputs.message.REQUIRED),
    acceptTerms: Yup.boolean().required(ValidMessages.inputs.acceptPersonalData.REQUIRED),
  });

  const handleSubmit = async (values: IFeedbackFieldData, { resetForm }: FormikValues) => {
    const token = getTokenFromStorage();

    if (token) {
      const phone = values.phone.replace(/[-()\s]/g, "");
      const text = `ФИО: ${values.name}\nТелефон: ${phone}\nEmail: ${values.email}\nСообщение: ${values.message}`;

      await dispatch(fetchFeedback({ text }));
      resetForm();
    } else {
      openAuthModal(dispatch);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={true}
    >
      {(formik) => {
        return (
          <Form>
            <div className={styles.formSection}>
              <NameInput name="name" lable="ФИО" />
              <ErrorMessage component="div" className={styles.errorMessage} name="name" />
            </div>
            <div className={styles.formSection}>
              <EmailInput name="email" lable="Email" />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="email"
              />
            </div>
            <div className={styles.formSection}>
              <PhoneInput name="phone" lable="Телефон" placeholder="+7 ___ ___ __ __" />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="phone"
              />
            </div>
            <div className={styles.formSection}>
              <TextareaInput
                name="message"
                placeholder="Текст сообщения"
                className={styles.textarea}
              />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="message"
              />
            </div>

            <PolicyCheckbox formik={formik} />

            <Button
              type="submit"
              newStyles={styles.button}
              disabled={formik.isSubmitting}
            >
              Отправить вопрос
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};
